import { WORKPLACE_TYPE_LABELS } from '../../../helpers/constants';

const STATUS_COLORS = {
	true: '#52c41a',
	false: '#ff4d4f'
};

export function getColumns(onBind, onEdit, onDelete, styles) {
	return [
		{
			title: 'Код РМ',
			dataIndex: 'external_id',
			key: 'external_id',
			sorter: (a, b) => a.external_id.localeCompare(b.external_id)
		},
		{
			title: 'Тип',
			dataIndex: 'type',
			key: 'type',
			render: (type) => WORKPLACE_TYPE_LABELS[type] ?? type
		},
		{
			title: 'Подразделение',
			dataIndex: 'division',
			key: 'division',
			sorter: (a, b) => (a.division?.title || '').localeCompare(b.division?.title || ''),
			render: (division) => division?.title ?? '—'
		},
		{
			title: 'Профессия',
			dataIndex: 'profession',
			key: 'profession',
			sorter: (a, b) => (a.profession?.title || '').localeCompare(b.profession?.title || ''),
			render: (profession) => profession?.title ?? '—'
		},
		{
			title: 'Должность',
			dataIndex: 'position',
			key: 'position',
			sorter: (a, b) => a.position.localeCompare(b.position)
		},
		{
			title: 'Класс условий',
			dataIndex: 'working_conditions',
			key: 'working_conditions',
			render: (value) => value ?? '—'
		},
		{
			title: 'Дата карты',
			dataIndex: 'sheet_date',
			key: 'sheet_date',
			render: (value) => value ?? '—'
		},
		{
			title: 'Статус',
			dataIndex: 'is_actual',
			key: 'is_actual',
			render: (is_actual) => (
				<span style={{ color: STATUS_COLORS[is_actual] }}>
					{is_actual ? 'Активно' : 'Деактивировано'}
				</span>
			)
		},
		{
			title: 'Привязки',
			key: 'bind',
			align: 'center',
			width: 120,
			render: (_, record) => (
				<button
					type="button"
					className={styles.linkButton}
					onClick={() => onBind(record)}
				>
					Настроить
				</button>
			)
		},
		{
			title: 'Изменить',
			key: 'edit',
			align: 'center',
			width: 90,
			render: (_, record) => (
				<button className={styles.iconButton} onClick={() => onEdit(record)}>
					<img
						className={styles.iconImage}
						src="/icons/edit-icon.svg"
						alt="edit"/>
				</button>
			)
		},
		{
			title: 'Удалить',
			key: 'delete',
			align: 'center',
			width: 90,
			render: (_, record) => (
				<button className={styles.iconButton} onClick={() => onDelete(record)}>
					<img
						className={styles.iconImage}
						src="/icons/delete-icon.svg"
						alt="delete"/>
				</button>
			)
		}
	];
}